import { getBaseFeature } from '@/assets/style/variable'

const styObj = {
  default: {
    '--button-color': '#a338fc',
  },
  echo: {
    '--button-color': '#ff3b30',
  },
  joychat: {
    '--button-color': '#20d887',
  },
  kiko: {
    '--button-color': '#FFEC00',
  },
  vava: {
    '--button-color': '#a338fc',
  },
  vibeo: {
    '--button-color': '#a338fc',
  },
}

export const pageCssVars = {
  methods: {
    cssVars() {
      const base = getBaseFeature()
      const pkg = this.packageName && styObj[this.packageName] ? styObj[this.packageName] : styObj.default
      return { ...base, ...pkg }
    },
  },
}
